// extracted by mini-css-extract-plugin
module.exports = {"root":"StockFilter_root__3dxCx","stockFilterButton":"StockFilter_stockFilterButton__2owI2","stockFilterButtonSelected":"StockFilter_stockFilterButtonSelected__32-ib"};